var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorShield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.99998V7.33331M8 9.99998H8.00667M13.7453 3.98931C11.6374 4.10126 9.57116 3.37239 8 1.96265C6.42885 3.37239 4.3626 4.10126 2.25467 3.98931C2.08502 4.64606 1.99945 5.32168 2 5.99998C2 9.72731 4.54934 12.86 8 13.748C11.4507 12.86 14 9.72798 14 5.99998C14 5.30531 13.9113 4.63198 13.7453 3.98931Z",
    stroke: "#F43F5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-shield.37344e8b17b94609c683b766d43741f6.svg";